import Desktop from './desktop/Dialog';
import Mobile from './mobile/Dialog';

export default {
  Desktop,
  Mobile,
};
